var _ellipse, _circle, _circle2, _circle3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 62,
    rx: 48,
    ry: 44,
    fill: "#38bdf8",
    fillOpacity: 0.18
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 52,
    r: 22,
    fill: "#061a24",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 48,
    r: 2.5,
    fill: "#fafcfb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 48,
    r: 2.5,
    fill: "#fafcfb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 58c3 4 7 6 10 6s7-2 10-6",
    stroke: "#a3d1c5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28l2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z",
    fill: "#fbbf24",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/wellness.43c2211705e41ee8247e024c740603df.svg";
export { ForwardRef as ReactComponent };